import React from "react";
import {Badge, CardBody, CardText, CardTitle} from "reactstrap";

const CustomFieldCard = ({data}) => {
  const {label = "", name = "", is_required, is_unique, type_label = ""} = data;

  return (
    <CardBody>
      <CardTitle tag="h3">{label} </CardTitle>
      <CardTitle tag="h3">{name} </CardTitle>
      <CardText>
        {`Object Types: `}
        <CustomRenderComponent data={data} renderKey="object_types" />
      </CardText>
      <CardText>{`Type: ${type_label}`}</CardText>
      <CardText>
        Required:
        <Badge color="" className="badge-dot ml-2">
          {is_required ? <i className="bg-success" /> : <i className="bg-warning" />}
        </Badge>
      </CardText>
      <CardText>
        Unique:
        <Badge color="" className="badge-dot ml-2">
          {is_unique ? <i className="bg-success" /> : <i className="bg-warning" />}
        </Badge>
      </CardText>
    </CardBody>
  );
};

export default CustomFieldCard;

export const CustomRenderComponent = ({data, renderKey}) => {
  const {object_type_details = []} = data;
  if (renderKey === "object_types") {
    return object_type_details.map((obj) => obj.model).join(", ");
  } else if (renderKey === "type") {
    return data.type_label;
  } else {
    return data[renderKey];
  }
};
